module.exports = __webpack_public_path__ + "assets/img/contacts.531c71ac.jpg";